import { callAPIWhiteToken } from '../config/api';

const PATH_API = process.env.REACT_APP_API;

export async function postData(data: any) {
	const url = `${PATH_API}/learning-users/join`;
	return await callAPIWhiteToken({
		url,
		method: 'POST',
		data: data,
	});
}

export async function getDataDetail(uniqueId: string) {
	const url = `${PATH_API}/learning-users/access?uniqueId=${uniqueId}`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}
